/**
 警告框
 */
export default function tip (content, widthNew, heightNew) {
  let body = document.body
  let div = document.createElement('div')
  let Text = document.createTextNode(content)
  div.style.position = 'fixed'
  div.style.width = widthNew + 'px'
  div.style.height = heightNew + 'px'
  div.style.zIndex = '100'
  div.style.left = '50%'
  div.style.top = '50%'
  div.style.marginLeft = -(widthNew / 2) + 'px'
  div.style.marginTop = -(heightNew / 2) + 'px'
  div.style.background = 'rgba(0,0,0,0.7)'
  div.style.color = '#fff'
  div.style.borderRadius = '4px'
  div.style.textAlign = 'center'
  div.style.lineHeight = heightNew + 'px'
  div.appendChild(Text)
  body.appendChild(div)
  function hide () {
    div.style.display = 'none'
  }
  setTimeout(hide, 3000)
}



// WEBPACK FOOTER //
// ./src/utils/alert.js